import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../Footer";
import axios from "axios";
import Swal from "sweetalert2";
import { toTitleCase } from "../helper/formatCarName";
import { SkeletonCard } from "../components/SkeletonLoader";
import CarCard from "../components/CarCard";

const MyListing = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const getDataFromlocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return serializedData ? JSON.parse(serializedData) : null;
    } catch (error) {
      console.error("Error getting data from localStorage:", error);
      return null;
    }
  };

  // Example usage:
  const storedUserPreferences = getDataFromlocalStorage("userData");
  // console.log(storedUserPreferences, "storedUserPreferencesstoredUserPreferences")

  useEffect(() => {
    if (storedUserPreferences === null) {
      Swal.fire({
        title: "Unauthorized",
        text: "You need to be logged in to access this page",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00889C",
        cancelButtonColor: "#d33",
        confirmButtonText: "Log In Now",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/login");
        } else {
          navigate("/");
        }
      });
      return;
    }
  }, []);

  function formatEuroAmount(amount) {
    const parts = amount.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }

  const getAllMyCar = async () => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/cars/mylist",
        {
          owner_id: storedUserPreferences?.id,
        }
      );
      // console.log(response?.data);
      if (response?.data?.status) {
        setData(response?.data?.data);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    getAllMyCar(); // Call the API when component mounts
  }, []);

  const deleteMyCar = async (id) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/car/delete",
        {
          car_id: id,
          owner_id: storedUserPreferences?.id,
        }
      );
      // console.log(response?.data);
      if (response?.data?.status) {
        getAllMyCar();
        // Handle the data as needed, e.g., update state, render UI, etc.
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };
  const editMyCar = async (id) => {
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/edit/mycar",
        {
          car_id: id,
          owner_id: storedUserPreferences?.id,
        }
      );
      // console.log(response?.data);
      if (response?.data?.status) {
        // console.log('hello',response?.data?.data);
        navigate("/edit/mycar", { state: { data: response?.data?.data } });
      } else {
        alert(response?.data?.message);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    }
  };

  const handleDelete = (id) => {
    const userConfirmed = window.confirm(
      "are you sure you want to delete the car data ?"
    );
    if (userConfirmed) {
      deleteMyCar(id);
    }
  };
  function backto() {
    window.history.back();
  }
  return (
    <>
      <Navbar />
      <div className="cl-page">
        <div className="container">
          <div className="d-flex align-items-center justify-content-between w-100 mb-3 flex-wrap gap-2">
            <div>
              <h3 className="cl-page-title">My Listings</h3>
              <p className="cl-page-subtitle">Cars you've listed for sale</p>
            </div>
            <div className="d-flex gap-2 flex-wrap">
              <button onClick={backto} type="button" className="cl-btn cl-btn-outline cl-btn-sm">
                <i className="fa fa-arrow-left"></i>Back
              </button>
              <Link to="/listdetails" className="cl-btn cl-btn-primary cl-btn-sm">
                <i className="fa-solid fa-plus"></i>Add Car
              </Link>
            </div>
          </div>
          {pageLoading ? (
            <SkeletonCard count={8} />
          ) : (
          <div className="row g-3">
            {data.length === 0 ? (
              <div className="col-12">
                <div className="cl-empty">
                  <div className="cl-empty-icon"><i className="fa-solid fa-car"></i></div>
                  <h6 className="cl-empty-title">No Cars Listed</h6>
                  <p className="cl-empty-text">You don't have any cars listed for sale right now.</p>
                  <Link to="/listdetails" className="cl-btn cl-btn-primary">
                    <i className="fa-solid fa-plus me-1"></i>Add Your First Car
                  </Link>
                </div>
              </div>
            ) : (
              data.map((car) => (
                <div
                  key={car.id}
                  className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6"
                >
                  <CarCard
                    carData={car}
                    topLeftContent={
                      <button
                        className="btn btn-sm btn-danger"
                        style={{ border: "none", cursor: "pointer", borderRadius: "6px", padding: "4px 8px" }}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDelete(car.id); }}
                      >
                        <i className="fa fa-trash" style={{ color: "white", fontSize: "13px" }}></i>
                      </button>
                    }
                    topRightContent={
                      <button
                        className="btn btn-sm btn-primary"
                        style={{ border: "none", cursor: "pointer", borderRadius: "6px", padding: "4px 8px" }}
                        onClick={(e) => { e.preventDefault(); e.stopPropagation(); editMyCar(car.id); }}
                      >
                        <i className="fa fa-edit" style={{ color: "white", fontSize: "13px" }}></i>
                      </button>
                    }
                  />
                </div>
              ))
            )}
          </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MyListing;
